module.exports = __webpack_public_path__ + "images/img-2O63Urq.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/11.png
// module id = 2348
// module chunks = 0